export default {
      id: "logo-votocto-usage",
      viewBox: "0 0 66.71 22.92",
      url: __webpack_public_path__ + "../images/sprites.svg#logo-votocto",
      toString: function () {
        return this.url;
      }
    }